import React, { useState } from 'react';
import styled from 'styled-components';
import { FiChevronDown, FiChevronUp, FiHelpCircle } from 'react-icons/fi';

const FAQSection = styled.section`
  background: #f7faf9;
  border-radius: 14px;
  padding: 48px 18px 40px 18px;
  max-width: 700px;
  margin: 48px auto 0 auto;
`;

const FAQTitle = styled.h4`
  font-size: 1.6rem;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: 26px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

const FAQList = styled.div``;

const FAQItem = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(218,1,92,0.04);
  margin-bottom: 14px;
  padding: 0;
`;

const FAQQuestion = styled.button`
  width: 100%;
  background: none;
  border: none;
  outline: none;
  font-size: 1.09rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.dark};
  padding: 18px 22px;
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;

const FAQAnswer = styled.div`
  padding: 0 22px 16px 22px;
  color: ${({ theme }) => theme.colors.secondary};
  font-size: 1rem;
  text-align: right;
`;

const faqs = [
  {
    q: 'كيف يتم احتساب العمولات؟',
    a: 'نحن نقدم عمولات تنافسية من بين الأدنى في السوق، وتُحتسب فقط على الرحلات المكتملة.'
  },
  {
    q: 'ما هي متطلبات التسجيل كسائق؟',
    a: 'رخصة قيادة سارية، سيارة بحالة جيدة، واجتياز الفحص الأمني. سنرشدك خلال كل خطوة من التسجيل.'
  },
  {
    q: 'متى يتم الدفع للسائقين؟',
    a: 'تتم المدفوعات شهرياً مباشرة إلى حسابك البنكي أو عبر وسيلة الدفع التي تختارها.'
  },
  {
    q: 'هل يوجد دعم للسائقين؟',
    a: 'نعم! لدينا فريق دعم متواجد لمساعدتك عبر التطبيق أو الهاتف في أي وقت.'
  }
];

const DriverFAQ: React.FC = () => {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);
  return (
    <FAQSection id="driver-faq">
      <FAQTitle><FiHelpCircle /><span style={{color: '#DA015C'}}>الأسئلة الشائعة</span> <span style={{color: '#000000'}}>للسائقين</span></FAQTitle>
      <FAQList>
        {faqs.map((item, idx) => (
          <FAQItem key={idx}>
            <FAQQuestion onClick={() => setOpenFAQ(openFAQ === idx ? null : idx)}>
              {item.q}
              {openFAQ === idx ? <FiChevronUp /> : <FiChevronDown />}
            </FAQQuestion>
            {openFAQ === idx && (
              <FAQAnswer>{item.a}</FAQAnswer>
            )}
          </FAQItem>
        ))}
      </FAQList>
    </FAQSection>
  );
};

export default DriverFAQ;
